import { Spinner } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import { useMediaQuery } from 'utils/mediaQuery';

import { Shimmer } from '../../../../../shimmer/shimmer';
import { StatusRow } from '../../../../../statusRow/statusRow';

const GERUNDS = [
  'Thinking…',
  'Working on it…',
  'Looking into it…',
  'Preparing your response…',
  'Checking the details…',
  'Putting it together…',
];

/** Two shimmer sweeps per gerund. */
const ROTATION_MS = 4000;

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** Shown while the assistant is busy and no tool is in flight. */
export const WorkingIndicator = (): JSX.Element => {
  const [prefersReducedMotion] = useMediaQuery(REDUCED_MOTION_QUERY);
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * GERUNDS.length),
  );

  useEffect(() => {
    if (prefersReducedMotion) return;

    const intervalId = setInterval(
      () => setIndex((previous) => (previous + 1) % GERUNDS.length),
      ROTATION_MS,
    );

    return () => clearInterval(intervalId);
  }, [prefersReducedMotion]);

  return (
    <StatusRow
      icon={<Spinner size={12} />}
      data-testid="sidekick-working-indicator"
    >
      <Shimmer>{GERUNDS[index]}</Shimmer>
    </StatusRow>
  );
};
